import Axios from 'axios'
import { Message } from 'element-ui'
import { showLoad, hideLoad } from '@/tools/loading.js' // 引入封装的loading方法
import { getCookie } from '@/tools/'
import router from '@/router/index.js'
import store from '@/store' // 引入 vuex 状态管理
import { apiEdition } from '@/config'



export default () => {
  // 发送请求前
  Axios.interceptors.request.use(function (config) {
    // 切换环境使用
    if (!config.url.includes('http') && process.env.NODE_ENV === 'development' && apiEdition === 'v1') config.url = apiEdition + '/' + config.url.replace('v2/', '')
    // 在发送请求之前做些什么
    config.headers['token'] = config.url.includes('jxcs.net') ? 'rushSkyMonkeyToken_20201203' : getCookie('Token') // 请求头带上token进行认证 //这个三元判断是为了请求冲天猴的时候携带token 这个token是石老板的
    // 打开加载中,其中京东的地址keyup搜索不需要加载中模态框
    if (!(config.method === 'get' && config.url === 'jd/client' && config.params.functionId === 'address/search') && !config.noLoading) {
      showLoad()
    }
    const multipartArr = ['SNSUploadImg','SendFilesToStores', 'LoadExcelByYongHui', 'JdStoreInfoCoordinateRecover', 'qiniup.com', 'RefreshJxPriceByExcel', 'FocusStoreSkusByExcel', 'UploadFakeJdThingMap', 'UpdateStoreSkusSpecTag', 'CreateUpcSkuByExcel']
    // 处理formData
    if ((config.method === 'post' || config.method === 'put') && !multipartArr.find(item => config.url.includes(item))) {
      if (Object.prototype.toString.call(config.data).indexOf('FormData') > -1) {
        let reqData = config.data
        let data = ''
        for (let attr of reqData) {
          data += `${encodeURIComponent(attr[0])}=${encodeURIComponent(attr[1])}&`
        }
        data = data.substring(0, data.length - 1)
        config.data = data
      }
    }
    if (config.timeout === 0) {
      config.timeout = 1000 * 60 * 60 // 设置请求超时时间 20分钟
    }
    return config
  }, function (err) {
    // 对请求错误做些什么
    return Promise.reject(err)
  })



  // 收到响应后
  Axios.interceptors.response.use(function (res) {
    // 对响应数据做点什么
    if (res.config.url === 'jd/client' && res.data.code !== '0') {
      hideLoad()
    }
    // token无效或过期跳转到登录页面
    if (res.data.code === '-2') {
      store.dispatch('LoginOut')
      router.push('/login')
    }
    return res
  }, function (err) {
    // 关闭加载中
    hideLoad()
    Message({
      message: '服务器请求出错'
    })
    // 对响应错误做点什么
    return Promise.reject(err)
  })
}



// WEBPACK FOOTER //
// ./src/tools/axios.js